export const ADMIN_SETTINGS_TAB_SECTIONS = [
  {
    value: "offers",
    sections: ["drop-policy", "alerts", "tags"],
  },
  {
    value: "channels",
    sections: ["in-app", "telegram", "whatsapp", "email", "web-push"],
  },
  { value: "ai", sections: ["ai-general", "ai-processing"] },
  { value: "personalization", sections: ["taste"] },
  { value: "catalog", sections: ["taxonomy", "artist-index"] },
] as const;

export type AdminSettingsTab = (typeof ADMIN_SETTINGS_TAB_SECTIONS)[number]["value"];
export type AdminSettingsSection = (typeof ADMIN_SETTINGS_TAB_SECTIONS)[number]["sections"][number];
